import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import isMobile from "ismobilejs";
import classNames from "classnames";

const hideErrors = {};
const telefono = tipo => (value, campos) => {
	let numero = (value != undefined)? value.replace("+","").replace(" ","") : "";
	let prefijo = (/lada/g.test(tipo)) ? "+" : "";
	
	if(numero != "" && isNaN(numero)) {
		let _temp = "";
		for(let i = 0; i < numero.length; i++) { 
			if(!isNaN(numero.substr(i,1))) {
				_temp  +=  numero.substr(i,1);
			}
		}
		numero = _temp;
	}

	if(numero != "") {
		campos[tipo] = prefijo + numero;
	} else {
		campos[tipo] = "";
	}
	
};
const validate = (campos) => {
	const errors = {};

	if(!campos.lada) {
		errors.lada = "Campo requerido.";
	}

	if(!campos.telefono) {
		errors.telefono = "Campo requerido.";
	}
	
	if (campos.lada && campos.telefono && ((campos.lada.length + campos.telefono.length) -1) != 10) {
		errors.telefono = "Tu número de teléfono con lada incluida debe ser de 10 dígitos.";
	}

	return errors;
};
const renderField = ({ input, label, type, cerrar, max, meta: { touched, error, warning } }) => {
	let errorClass = classNames({"error-wrap": true, "hidden": hideErrors[input.name]});
	return (
		<div>
			<input {...input} type={type} maxLength={max} />
			{touched && (error && 
				<div className={errorClass}>
					<div className="msj-error">
						<p><span>{error}</span></p>
					</div>
				</div>)
			}
		</div>
	);
};

class InconvenientesForm extends React.Component {

	focus = (e) => {
		hideErrors[e.target.name] = false;
	}

	cerrar = (e) => {
		hideErrors[e] = true;
		let value = document.querySelector("input[name="+e+"]").value == ""? " " : "";
		this.props.change(e, value);
	}

	componentWillMount = () => {
		this.props.change("tipo", "fijo");
	}
	
	aceptar = (_llamar) => {
		this.props.handleSubmit(values => this.props.onSubmit({ ...values, llamar: _llamar }))();
	}
	
	render () {
		const { handleSubmit, pristine, reset, submitting } = this.props;
		return (
			<form onSubmit={handleSubmit}>
				<div className="text-content">
					<div className="datos-wrap row">
						<h3 className="text-center mt-34">Inconvenientes en tu registro</h3>
						<div className="col-xs-12">
							{/*<div className="text-center mt-34 show-mobile">
								<img src={require("../img/vector-cuenta-bloqueada.png")} alt="" />
							</div>*/}
							<div className="texto-15 mt-34 gray-text">
								<p>Para poder concluir tu registro es necesario hacerlo de manera asistida. Nos comunicaremos contigo, 
								recibirás una llamada de nuestro Call center en un lapso máximo de 48 hrs. o si prefieres puedes llamarnos 
								a nuestra <span className="blue-text">Línea GNP</span> al <span className="orange-text">55 5227 9000</span> 
								o al <span className="orange-text">800 400 9000</span> en la opción 7 de lunes a viernes de 7:00 a 20:00 y 
								sábado de 8:00 a 16:00 (Hora del centro de México-GMT - 6 horas).</p>
							</div>
						</div>
						<div className="col-md-12 col-xs-12 mt-25">
							<div className="row mt-25">
								<div className="col-xs-12 col-md-6">
									<div className="row">
										<div className="col-xs-8">
								<div  className="input-wrap no-margin">
												<label>Tipo de teléfono</label>
												<span className="clearfix input-active">
													<Field  component="select" name="tipo" className="col-xs-1">
														<option value="fijo">Fijo</option>
														<option value="celular">Celular</option>
													</Field>
												</span>
											</div>
										</div>
										<div className="col-xs-4">
											<div className="input-wrap">
												<label>Extensión</label>
												<span className="clearfix">
													<Field name="extension" component={renderField} cerrar={this.cerrar.bind(this,"extension")} onFocus={this.focus.bind(this)} type="text" max="5" validate={telefono("extension")} />
												</span>
											</div>
										</div>
									</div>
								</div>
								<div className="col-xs-12 col-md-6">
									<div className="row">
										<div className="col-xs-4">
											<div className="input-wrap">
												<label htmlFor="">Lada</label>
												<span className="clearfix input-active">
													<Field name="lada" component={renderField} cerrar={this.cerrar.bind(this,"lada")} onFocus={this.focus.bind(this)} type="text" max="4" validate={telefono("lada")} />
												</span>
											</div>
										</div>
										<div className="col-xs-8">
											<div className="input-wrap">
												<label htmlFor="">Teléfono</label>
												<span className="clearfix input-active">
													<Field name="telefono" component={renderField} cerrar={this.cerrar.bind(this,"telefono")} onFocus={this.focus.bind(this)} type="text" max="8" validate={telefono("telefono")} />
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="text-center aceptar-cancelar-btn">
						<a href="javascript:void(0)" onClick={this.aceptar.bind(this, false)}>Recibir llamada</a>
						{ isMobile.any == true &&
							<a href="javascript:void(0)" onClick={this.aceptar.bind(this, true)} className="orange-text">Llamar ahora</a>
						}
					</div>
				</div>
			</form>
		);
	}
}

InconvenientesForm = reduxForm({form: "registro-asistido-inconvenientes", validate})(InconvenientesForm);

export default InconvenientesForm;


// WEBPACK FOOTER //
// ./src/registro-asistido/inconvenientes.frm.js